import React from 'react';
import ReactDOM from 'react-dom/client';
import {Chat} from "./plugin/plugin/Chat";
import {ChatContextProvider} from "./plugin/plugin/ChatContext";

(function() {
    const container = document.getElementById('wv-chat-bot-wrapper');

    if (container) {
        const root = ReactDOM.createRoot(container);
        root.render(
            <ChatContextProvider>
                <Chat/>
            </ChatContextProvider>
        );
    }
})();

